import React from 'react';
import styles from './TabBodyContainer.module.scss';
import { TabBodyContainerProps } from './types';

const TabBodyContainer = (props: TabBodyContainerProps) => {
  const {
    children,
    onScroll = null
  } = props;

  return (
    <div className={styles.container}
      onScroll={onScroll}
    >
      {children}
    </div>
  );
};

export default TabBodyContainer;
